var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { t } from 'i18next';
import _ from 'lodash';
import { livequeueConsultationService, scheduledAppointmentsService } from 'ziphy-web-shared/basic/api';
import { $router } from 'ziphy-web-shared/basic/utils/router';
import { formatDate } from 'ziphy-web-shared/basic/utils/time';
import TimeSlotPicker from '@nedoShared/features/scheduledAppointments/timeSlotPicker/TimeSlotPicker';
import { Button } from '@booking/pages/liveqHome/liveqSteps/components/button';
import { ProviderItem } from '@booking/pages/liveqHome/liveqSteps/components/forms/scheduleStep/bookingStep';
import { fillDates } from '@booking/pages/liveqHome/liveqSteps/shared/utils/helpers';
import styles from '../index.module.scss';
export const TimeSelect = ({ onChangeStep = (_) => { } }) => {
    const [weekDates, setWeekDates] = useState(fillDates());
    const today = weekDates[0];
    const [selectedDate, setSelectedDate] = useState(today);
    const [selectedSlot, setSelectedSlot] = useState();
    const [selectedProvider, setSelectedProvider] = useState();
    const changeProvider = (provider) => {
        setSelectedProvider(provider);
    };
    const changeDate = (date) => {
        setSelectedDate(date);
        setSelectedSlot(undefined);
        setSelectedProvider(undefined);
    };
    const { consultationId } = useParams();
    const [selectedWindow, setSelectedWindow] = useState({
        key: null,
        value: [],
    });
    const [staff, setStaff] = useState([]);
    const changeSlot = (window, list) => {
        setSelectedWindow(window);
        setStaff(list);
        if (selectedProvider && !list.some(el => el.role_id === selectedProvider.role_id)) {
            setSelectedProvider(undefined);
        }
    };
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const requestParams = useMemo(() => {
        const result = {
            liveq_id: consultationId,
            timezone: timezone
        };
        return result;
    }, []);
    const [isBooking, setIsBooking] = useState(false);
    const book = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsBooking(true);
        try {
            const response = yield scheduledAppointmentsService.create({ liveq_id: consultationId, provider_role_id: selectedProvider.role_id, start: `$datetime:${selectedWindow.key}` });
            const res = yield livequeueConsultationService.getConsultationById(consultationId);
            const chatId = res.chat_id;
            $router.executeAutoTarget({ to: `/orders/${consultationId}/chat/${chatId}` }, { type: 'replace' });
        }
        catch (e) {
        }
        setTimeout(() => setIsBooking(false), 1000);
    });
    useEffect(() => {
        let i = 0;
        if (selectedProvider) {
            i++;
        }
        if (selectedWindow.key) {
            i++;
            i++;
        }
        onChangeStep(i);
    }, [selectedProvider, selectedWindow]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: styles.schedule }, { children: [_jsx("div", Object.assign({ className: styles.scheduleLabel }, { children: "Visit Date" })), _jsx(TimeSlotPicker, { value: selectedWindow, onChange: changeSlot, 
                        // @ts-ignore
                        requestParams: requestParams, placeTimezone: timezone })] })), staff.length > 0 && (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: styles.providersLabel }, { children: "Provider" })), _jsx("div", Object.assign({ className: styles.providers }, { children: staff.map((provider) => _jsx(ProviderItem, { isSelected: provider.name === (selectedProvider === null || selectedProvider === void 0 ? void 0 : selectedProvider.name), item: provider, onChange: changeProvider }, provider.role_id)) }))] })), selectedProvider && _jsx(Button, { loading: isBooking, onClick: book, label: _.isEmpty(selectedWindow)
                    ? t('btn.select_time_slot')
                    : formatDate(selectedWindow.key, {
                        format: 'datetimeFullNoYear',
                        timezone: timezone,
                    }) })] }));
};
